// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { WidgetDefinition } from "@insite/client-framework/Types/ContentItemDefinitions";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { useScript } from "@werner/App/Hooks/useScript";
import React from "react";

export const enum fields {
    scriptSrc = "scriptSrc",
}

interface ExternalScriptWidgetProps extends WidgetProps {
    fields: {
        [fields.scriptSrc]: string;
    };
}

type Props = ExternalScriptWidgetProps;

const ExternalScriptWidget: React.FC<Props> = ({ fields }) => {
    useScript(fields.scriptSrc);

    return null;
};

export const definition: WidgetDefinition = {
    group: "Basic",
    fieldDefinitions: [
        {
            displayName: "Script Src",
            name: fields.scriptSrc,
            fieldType: "Contextual",
            editorTemplate: "TextField",
            defaultValue: "",
            isRequired: true,
        },
    ],
};

const widgetModule: WidgetModule = {
    component: ExternalScriptWidget,
    definition,
};

export default widgetModule;